import './Modal.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { closeModal } from "../../slices/modalSlice";

import Close from "@mui/icons-material/Close";

import { IconButton } from "../Buttons/Buttons";

export const Modal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.modal.isOpen);
    const content = useSelector((state) => state.modal.content);
    const closeable = useSelector((state) => state.modal.closeable);

    if (!isOpen) {
        return null
    }

    const handleClose = () => {
        dispatch(closeModal());
    };

    return (
        <div className={"modal"}>
            <div className={"modal_container"}>
                {closeable && (
                    <div className={"modal_close"}>
                        <IconButton Icon={Close} onClick={handleClose}/>
                    </div>
                )}
                <div className={"modal_content"}>
                    {content}
                </div>
            </div>
        </div>
    )
}